<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import KanbanReportWidget from 'kanban/components/reports/KanbanReportWidget.vue';
import Avatar from 'dashboard/components-next/avatar/Avatar.vue';
import { formatNumber } from 'kanban/helper/reportFormatters';

// Desempenho por agente (so admin, so multi-agente): carga aberta ao vivo,
// sem resposta e resolvidas no periodo.
const props = defineProps({
  agents: {
    type: Array,
    default: () => [],
  },
  isLoading: {
    type: Boolean,
    default: false,
  },
});

const { t, locale } = useI18n();

const rows = computed(() => props.agents || []);
const isEmpty = computed(() => rows.value.length < 2);
</script>

<template>
  <KanbanReportWidget
    v-if="!isEmpty || isLoading"
    class="!rounded-2xl !border-n-weak !bg-white dark:!bg-n-solid-2"
    :title="t('VINCTO_HOME.AGENTS.TITLE')"
    :info-text="t('VINCTO_HOME.AGENTS.INFO')"
    :is-loading="isLoading"
  >
    <div class="overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr
            class="text-left text-[11px] uppercase tracking-[0.04em] text-n-slate-10"
          >
            <th class="pb-2 font-semibold">
              {{ t('VINCTO_HOME.AGENTS.AGENT') }}
            </th>
            <th class="pb-2 font-semibold text-right">
              {{ t('VINCTO_HOME.AGENTS.OPEN') }}
            </th>
            <th class="pb-2 font-semibold text-right">
              {{ t('VINCTO_HOME.AGENTS.UNATTENDED') }}
            </th>
            <th class="pb-2 font-semibold text-right">
              {{ t('VINCTO_HOME.AGENTS.RESOLVED') }}
            </th>
          </tr>
        </thead>
        <tbody class="divide-y divide-n-weak">
          <tr v-for="agent in rows" :key="agent.id">
            <td class="py-2">
              <div class="flex items-center gap-2 min-w-0">
                <Avatar
                  :src="agent.thumbnail"
                  :name="agent.name"
                  :size="24"
                  rounded-full
                />
                <span class="truncate text-n-slate-12">{{ agent.name }}</span>
              </div>
            </td>
            <td class="py-2 text-right text-n-slate-12">
              {{ formatNumber(agent.open, locale) }}
            </td>
            <td
              class="py-2 text-right"
              :class="agent.unattended ? 'text-n-ruby-11' : 'text-n-slate-12'"
            >
              {{ formatNumber(agent.unattended, locale) }}
            </td>
            <td class="py-2 text-right text-n-slate-12">
              {{ formatNumber(agent.resolved, locale) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </KanbanReportWidget>
</template>
